import 'dotenv/config';

export const gtmConfig = {
  gtmId: process.env.REACT_APP_GTM_ID,
};
